import { defineComponent as _defineComponent } from 'vue'
import BaseButton from "@/components-UI/BaseButton.vue";
import SvgEdit from "@/assets/icons/pencil.svg";
import SvgReload from "@/assets/icons/reload.svg";
import SvgCheck from "@/assets/icons/check.svg";
import BaseLineLoader from "@/components-UI/BaseLineLoader.vue";
import BaseTooltip from "@/components-UI/BaseTooltip.vue";

interface Props {
    title?: string;
    isShowEditButtons?: boolean;
    isEdit?: boolean;
    isLoading?: boolean;
    isDisableEdit?: boolean;
    isTransparent?: boolean;
    isXlTitle?: boolean;
    disabledSaveButton?: boolean;
    disabledTooltipSaveButton?: boolean;
    saveButtonTooltipPosition?: string;
    forcedInclusionTitle?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseEditableCard',
  props: {
    title: null,
    isShowEditButtons: { type: Boolean, default: true },
    isEdit: { type: Boolean },
    isLoading: { type: Boolean },
    isDisableEdit: { type: Boolean },
    isTransparent: { type: Boolean },
    isXlTitle: { type: Boolean },
    disabledSaveButton: { type: Boolean },
    disabledTooltipSaveButton: { type: Boolean, default: true },
    saveButtonTooltipPosition: { default: 'top' },
    forcedInclusionTitle: { type: Boolean }
  },
  emits: ['update:is-edit', 'reset'],
  setup(__props: any, { emit }) {

const props = __props as { title?: string, isShowEditButtons: boolean, isEdit?: boolean, isLoading?: boolean, isDisableEdit?: boolean, isTransparent?: boolean, isXlTitle?: boolean, disabledSaveButton?: boolean, disabledTooltipSaveButton: boolean, saveButtonTooltipPosition: string, forcedInclusionTitle?: boolean }





return { __sfc: true,props, emit, BaseButton, SvgEdit, SvgReload, SvgCheck, BaseLineLoader, BaseTooltip }
}

})